import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import VueClipboard from 'vue-clipboard2'
import MessagePlugin from './plugin/message'
import '@/plugin/matomo'
import '@/utils/validate.js'
import '@/plugin/dayjs.js'
import('@/assets/css/main.scss')

// 提前初始化 iframe 通訊服務，確保從應用程式載入開始就能緩存消息
import '@/utils/iframeMessaging'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import specific icons */
import {
  faChevronLeft,
  faChevronRight,
  faCreditCard,
  faInfoCircle,
  faArrowRight,
  faXmark,
  faCircleCheck,
  faThumbsUp,
  faCheckCircle,
  faHouse,
  faCircleXmark,
  faReceipt,
  faRightToBracket,
  faWallet,
  faSackDollar,
  faMoneyCheckDollar,
  faPenToSquare,
  faShop
} from '@fortawesome/free-solid-svg-icons'


/* import specific icons */
import {
  faLoader,
  faBadgeCheck,
  faCircleExclamation
} from '@fortawesome/pro-solid-svg-icons'


import {
  faCommentDots,
  faCircleCheck as farCircleCheck,
  faCheckCircle as faCheckCircleRegular,
} from '@fortawesome/free-regular-svg-icons'


import {
  faCircleExclamation as faCircleExclamationRegular,
  faCopy,
  faCircleInfo
} from '@fortawesome/pro-regular-svg-icons'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* add icons to the library */
library.add(
  faChevronLeft,
  faChevronRight,
  faCreditCard,
  faCheckCircle,
  faInfoCircle,
  faArrowRight,
  faXmark,
  faCircleExclamation,
  faCircleCheck,
  faThumbsUp,
  faHouse,
  faCommentDots,
  farCircleCheck,
  faCopy,
  faCircleXmark,
  faBadgeCheck,
  faReceipt,
  faLoader,
  faCheckCircleRegular,
  faCircleExclamationRegular,
  faCircleInfo,
  faRightToBracket,
  faWallet,
  faSackDollar,
  faMoneyCheckDollar,
  faPenToSquare,
  faShop
)

/* add font awesome icon component */
Vue.component('fontIcon', FontAwesomeIcon)

Vue.use(VueAxios, axios)
Vue.use(VueCookies)
Vue.use(VueClipboard)
Vue.use(MessagePlugin)

Vue.config.productionTip = false
const observableGlobalState = Vue.observable({
  globalState: {
    routeInitialize: false
  }
})
Object.defineProperty(Vue.prototype, '$globalState', {
  get() {
    return observableGlobalState.globalState
  },
  set(value) {
    observableGlobalState.globalState = value
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
